import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { BitbucketTableDataset } from 'app/model/dataset/bitbucket.dataset';
import {
    TabularTypeDatasetAdapter,
    tabularTypeDatasetAdapts
} from 'app/model/adapters/datasets/tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(BitbucketTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class BitbucketTableDatasetAdapter extends TabularTypeDatasetAdapter<
    BitbucketTableDataset,
    Model.DatasetResource
> {
    protected async _toResource(dataset: BitbucketTableDataset): Promise<Model.DatasetResource> {
        return this._toResourceInternal(dataset, Metamodel.modelFor(BitbucketTableDataset).name);
    }

    protected async _toModel(
        resource: Model.DatasetResource,
        dataset?: BitbucketTableDataset
    ): Promise<BitbucketTableDataset> {
        return this._toModelInternal(resource, dataset, BitbucketTableDataset.MODEL);
    }
}
